export class Lov {
  id?:number;
  type:string|null = null;
  category:string|null = null;
  value:string|null = null;

  constructor(raw?:{[id:string]:any}) {
    this.type = raw && raw.type || ''
    this.value = raw && raw.value || ''
    this.category = raw && raw.category || ''
    if (raw && raw.id) {
      this.id = raw.id;
    }
  }

  get isValid() {
    return this.type && this.value != null;
  }

  get typeName():string {
    return this.type != null && Lov.Types['' + this.type] || `Unknown ${this.type}`
  }

  static Types:{[id:string]:string} = {
    'grease': 'Grease',
    'work_detail': 'Work Detail',
    'lubricant': 'Lubricant',
    'report_photo_caption': 'Report Photo Caption'
  }

  static clone(from:Lov): Lov {
    return new Lov(from)
  }
}